(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.currentScrollTop = 0;

      this.setHeaderHeight();

      // Update header height on window resize
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      // Scroll event handler
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    setHeaderHeight() {
      // Set the header height as a CSS variable
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        this.makeSticky();
      } else {
        this.removeSticky();
      }

      this.currentScrollTop = scrollTop;
    }

    makeSticky() {
      // Add the sticky class to the header
      this.header.classList.add('shopify-section-header-sticky');
    }

    removeSticky() {
      // Remove the sticky class from the header
      this.header.classList.remove('shopify-section-header-sticky');
    }
  }

  // Define the custom element
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
